// extracted by mini-css-extract-plugin
export default {"containerApp":"App_containerApp__02hfB"};